function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M479.17,229.17c-11.5,0-20.83,9.33-20.83,20.83c0,114.88-93.46,208.33-208.33,208.33S41.67,364.88,41.67,250 S135.13,41.67,250,41.67c55.93,0,108.43,21.85,147.83,61.54c8.1,8.16,21.3,8.21,29.46,0.1c8.17-8.1,8.21-21.3,0.1-29.47 C380.11,26.23,317.1,0,250,0C112.15,0,0,112.15,0,250s112.15,250,250,250c137.84,0,250-112.15,250-250 C500,238.5,490.67,229.17,479.17,229.17z M279.46,250l47.77-47.77c8.14-8.14,8.14-21.32,0-29.46s-21.32-8.14-29.46,0L250,220.54 l-47.77-47.77c-8.13-8.14-21.33-8.14-29.46,0c-8.14,8.14-8.14,21.32,0,29.46L220.54,250l-47.77,47.77c-8.14,8.14-8.14,21.32,0,29.46 c4.06,4.07,9.4,6.1,14.73,6.1s10.67-2.03,14.73-6.1L250,279.46l47.77,47.77c4.07,4.07,9.4,6.1,14.73,6.1s10.66-2.03,14.73-6.1 c8.14-8.14,8.14-21.32,0-29.46L279.46,250z"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.7e557edb.svg";
export { ForwardRef as ReactComponent };